import ApiClient, { handleApiCall } from "../api";

/** Store list/detail reads — no global loader; list page uses inline skeleton. */
export const getStore = (page: number = 1, limit: number = 10) =>
  ApiClient.get(`stores?page=${page}&limit=${limit}`);

export const getByStoreID = (storeId: number) => ApiClient.get(`stores/${storeId}`);

// POST /stores is intentionally slow today: it does an S3 logo upload,
// bcrypt hash, role lookup, and several DB writes inside a single
// transaction. The global ApiClient timeout (60s) is too tight for this
// endpoint on slower networks. We override it to 3 minutes *here only* so
// other endpoints keep their fast-fail behaviour, and handleApiCall's UI
// watchdog auto-aligns with this value.
//
// NOTE: this is a ceiling — fast responses are unaffected. Once POST /stores
// p95 is under ~2s (profiling + idempotency-key work), drop this back.
export const createStore = (postPayload: any) =>
  handleApiCall(
    "post",
    `stores/`,
    postPayload,
    {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: 180000,
    }
  );

export const updateStore = (storeId: number, patchPayload:any ) => handleApiCall("patch", `stores/${storeId}`, patchPayload, { headers: { "Content-Type": "multipart/form-data" } });

export const deleteSelectedStoreImage = (storeId: number, imageLabel: string) => handleApiCall("delete", `stores/${storeId}/delete-image/${imageLabel}`);

// Store state management APIs
export const getStoreState = (storeId: number) => handleApiCall("get", `stores/${storeId}/state`);

export const updateStoreOverride = (storeId: number, payload: { state: string; ttl_seconds?: number; reason_code?: string; note?: string }) => handleApiCall("put", `stores/${storeId}/override`, payload);

export const syncStoreToBuyer = (storeId: number) => handleApiCall("post", `/ondc/sync-store-to-buyer`, { store_id: storeId });

export const getStoreStatusOverrideLogs = (
  page: number = 1,
  limit: number = 20,
  storeId?: number,
) => {
  const params = new URLSearchParams({
    page: String(page),
    limit: String(limit),
  });
  if (storeId) {
    params.append("store_id", String(storeId));
  }
  return handleApiCall("get", `stores/status-override-logs?${params.toString()}`);
};